document.addEventListener("DOMContentLoaded", function () {
    // Sidebar mobile (my account)
    const accountSlider = document.querySelector(".my-account-sidebar__items");
    const accountArrow = document.querySelector(".my-account-sidebar__items_arrow");

    // Product filtracion mobile (catalog filter)
    const filterSlider = document.querySelector(".product-catalog-filters");
    const filterArrow = document.querySelector(".product-catalog-filter_arrow");

    setupScroll(accountSlider, accountArrow);
    setupScroll(filterSlider, filterArrow);

    function setupScroll(slider, arrow) {
        if (!slider || !arrow) return;

        slider.addEventListener("scroll", () => {
            const maxScroll = slider.scrollWidth - slider.clientWidth;
            const currentScroll = slider.scrollLeft;

            arrow.classList.toggle("hidden", currentScroll > 0);

            slider.style.webkitMask = currentScroll >= maxScroll - 1 ? "none" : "";
            slider.style.mask = currentScroll >= maxScroll - 1 ? "none" : "";
        });

        arrow.addEventListener("click", function () {
            startSmoothScroll(slider);
        });
    }

    function startSmoothScroll(slider) {
        const scrollAmount = slider.clientWidth * 0.3;
        const start = slider.scrollLeft;
        const end = start + scrollAmount;
        const duration = 600;
        const startTime = performance.now();

        function smoothScroll(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            slider.scrollLeft = start + (end - start) * easeOutQuad(progress);

            if (progress < 1) {
                requestAnimationFrame(smoothScroll);
            }
        }

        function easeOutQuad(t) {
            return t * (2 - t);
        }

        requestAnimationFrame(smoothScroll);
    }
});
